import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { generateQueryParams } from "../../utils/generateQueryParams";

export const getAllSupportRequests = createAsyncThunk(
  "supportRequest/getAll",
  async (arg) => {
    const query = generateQueryParams(arg);
    const response = await api.get(`/support-request?${query}`);
    return response.data;
  }
);

export const updateSupportRequestStatus = createAsyncThunk(
  "supportRequest/update",
  async (supportRequestId) => {
    const response = await api.put(`/support-request/${supportRequestId}/status`);
    return response.data;
  }
);

